import { QuizStats } from "@/context/QuizContext";

import QandA from "./QandA";
import Button from "@/components/Button";

function QuestionCard({ register }) {
  const {
    nextQuestion,
    numberOfQuestions,
    currentQuestionNumber,
    currentQuestionData,
    previousQuestion,
  } = QuizStats();

  return (
    <div className="relative col-span-3 py-10 lg:px-10 lg:col-span-2 bg-gray-color-lighter h-fit">
      <div className="flex items-center justify-center w-full">
        <div className="bg-white absolute top-[-30px] p-4  rounded-3xl shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px] text-blue-color-primary">
          السؤال رقم {currentQuestionNumber + 1} من {numberOfQuestions}
        </div>
      </div>

      <div className=" bg-gray-color-lighter">
        {/* Question and options  */}
        <QandA
          currentQuestionData={currentQuestionData}
          register={register}
        />

        <div className="flex justify-between">
          <Button
            name="go back"
            onClick={(e) => {
              e.preventDefault();
              previousQuestion();
            }}
            type="secondry"
          >
            السابق
          </Button>
          {currentQuestionNumber + 1 !== numberOfQuestions ? (
            <Button
              name="next"
              onClick={(e) => {
                e.preventDefault();
                nextQuestion();
              }}
              type="primary"
            >
              التالي
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default QuestionCard;
